import "./Banner.css";
import "../Features/Features.css"
import pin from "../../../../imagens/pim.webp";
import { VscVerifiedFilled } from "react-icons/vsc";
import { MdOutlinePhotoCamera } from "react-icons/md";
import { AiOutlineAudio } from "react-icons/ai";

import { BiSolidFilePdf } from "react-icons/bi";
import { CiCalendar } from "react-icons/ci";
import { TbDownload } from "react-icons/tb";
import { TbMoneybag } from "react-icons/tb";
import { TbSquareRoundedCheckFilled } from "react-icons/tb";
import { IoArrowUndoOutline, IoDocumentTextOutline } from "react-icons/io5";
import { PiBatteryFullFill, PiCertificate } from "react-icons/pi";
import { QRCode } from 'antd';
import { useEffect, useRef, useState } from "react";
import { FaWhatsapp } from "react-icons/fa6";
import { LazyLoadImage } from "react-lazy-load-image-component";


export function Banner({ component1Ref, isHiddenBanner, scrollToSobre }) {

    const [showPixMessage, setShowPixMessage] = useState(false);
    const [showBoleto] = useState(false);
    const [showQR, setshowQR] = useState(false);
    const [showBoletoArquivo] = useState(false);
    const [autoSimulating, setAutoSimulating] = useState(true);

    const [activeChatComponent] = useState('RecebimentoDAS');

    const chatRef = useRef(null);

    useEffect(() => {
        if (!autoSimulating) return;

        const timer1 = setTimeout(() => {
            setShowPixMessage(true);
        }, 1500);

        const timer2 = setTimeout(() => {
            setshowQR(true);
            if (!showBoletoArquivo) {
                 setAutoSimulating(false);
            }
        }, 2900);



        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
    }, [autoSimulating]);

    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }

    }, [showPixMessage, showQR, showBoleto, showBoletoArquivo]);

    const RecebimentoDAS = () => {
         return (
             <div className="message-2 received" style={{ width: "100%" }}>
                 <div className="container-box-pdf-2">
                     <div className="icon-pdf-2"><BiSolidFilePdf /></div>
                     <div className="info-pdf-2">
                         <div className="margin-b-5"><label>DAS_MEI.pdf</label></div>
                         <div className="sub-span-kb-2"><span>289 KB PDF</span></div>
                     </div>
                     <div className="style-down"><TbDownload /></div>
                 </div>

                 <strong className="style-strong-2">Olá Aqui é o PIM, Seu Contador Digital do Meu Contador Online.</strong>
                 <p>Tenho ótimas notícias! Seu documento DAS-MEI já está disponível para você cliente <strong>Zap-MEI Meu Contador online</strong>,
                     para facilitar sua vida ainda mais, estou te enviando em anexo seu documento.</p>

                 <p><strong>Segue abaixo as informações:</strong></p>

                 <div className="display-flex-chat-2">
                     <div><CiCalendar /></div>
                     <div>Vencimento: 25/10/2025</div>
                 </div>

                 <div className="display-flex-chat-2">
                     <div><TbMoneybag /></div>
                     <div>Valor: R$100,00</div>
                 </div>

                 <div className="display-flex-chat-2">
                     <div><TbSquareRoundedCheckFilled /></div>
                     <div><strong>Importante lembrar: </strong><span>Não é necessário me responder. Até Mais!</span></div>
                 </div>

                 <p>Escolha a melhor forma para o seu pagamento. Até Mais!!!</p>

                 <div>
                     <div
                         className="display-flex-chat-2"
                         style={{ borderBottom: "1px solid #e5e5e5", cursor: "default" }}
                     >
                         <div><IoArrowUndoOutline /></div>
                         <div style={{ color: "#007aff" }}>Pix</div>
                     </div>

                     <div
                         className="display-flex-chat-2"
                         style={{ borderBottom: "1px solid #e5e5e5", cursor: "default" }}
                     >
                         <div><IoArrowUndoOutline /></div>
                         <div style={{ color: "#007aff" }}>Boleto</div>
                     </div>
                 </div>
             </div>
         )
    }

    return (
        <>
            <div
                ref={component1Ref}
                className={`component-1 ${isHiddenBanner ? 'hide' : ''}`}>
                    <section className="container-banner banner">
                        <div className="banner-content">
                            <h1 className="banner-title">
                                Chega de portal do governo: <br/> o
                                <span> ZAP MEI </span>
                                <strong>resolve sua rotina em minutos, no <span>WhatsApp</span>. </strong>
                            </h1>
                            <p className="banner-subtitle">
                                
                                O <strong style={{color: "#27ae60"}}> ZAP MEI </strong> é seu agente contábil no WhatsApp para emitir notas, agendar notas automáticas,
                                receber DAS no prazo, fazer a declaração anual (DASN) e te alertar sobre o limite de
                                faturamento, sem senha, sem plataforma, sem perder tempo.
                            </p>

                        <div className="banner-buttons">
                            {/**<a href="#ContratarZapMei" style={{ textDecoration: "none" }}>
                                    <button class="quero-agora" role="button">Quero pagar sem estresse!</button>
                                </a> */}
                            <button className="quero-saber" role="button" style={{ fontWeight: "bold" }} onClick={scrollToSobre}>
                                Quero saber mais do Zap-MEI
                            </button>
                        </div>
                        </div>

                        <div id="phone-banner" className="phone-2">
                            <div className="batery"><PiBatteryFullFill /></div>
                            <div className="notch-2"></div>
                            <div className="perfil-pin-2">
                                <div className="perfil">
                                    <div className="photo-perfil">
                                        <LazyLoadImage
                                            className="img-pin"
                                            src={pin}
                                            alt="Pin Profile"
                                            effect="blur"
                                        />

                                    </div>
                                    <div>
                                        <div className="nome-perfil">
                                            <label>Pim</label>
                                        </div>
                                        <div className="subtitle">
                                            <span>Meu Contador Online</span>
                                            <VscVerifiedFilled className="icon-verifi" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="screen-2">
                                <div
                                    className="chat-2"
                                    ref={chatRef}
                                    style={{ marginBottom: 50, overflowY: 'auto', height: '100%', display: 'flex', flexDirection: 'column' }}
                                >
                                    {activeChatComponent === 'RecebimentoDAS' && <RecebimentoDAS />}

                                    {showPixMessage && (
                                        <div
                                            className={`message-2 sent ${showPixMessage ? 'show' : ''}`}
                                            style={{ alignSelf: 'flex-end' }}
                                        >
                                            <strong>Pix</strong>
                                        </div>
                                    )}

                                    {showBoletoArquivo && (
                                        <div
                                            className="message-2 sent show"
                                            style={{ alignSelf: 'flex-end' }}
                                        >
                                            <strong>Boleto</strong>
                                        </div>
                                    )}

                                    {showQR && (
                                        <div
                                            className={`message-2 received show`}
                                            style={{ width: "100%", justifyContent: "center", display: "grid" }}
                                        >
                                            <strong className="style-strong-2" style={{ textAlign: "center" }}>Pronto, agora é só pagar a sua DAS por esse pix</strong>
                                            <div className='card-qr-code'>
                                                <QRCode
                                                    errorLevel="H"
                                                    value="https://ant.design/pix-ficticio-123"
                                                    icon={pin}
                                                />
                                            </div>
                                            <div className="display-flex-chat-2" style={{ flexDirection: 'column', textAlign: 'center' }}>
                                                <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>Chave Copia e Cola:</p>
                                                <div style={{ wordBreak: 'break-all', fontWeight: 'bold' }}>1198765rgqwd43210wf12345678wf90123wqfqd4567890</div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="input-phone-2">
                                    <div className="icon-plus-wrapper-2">+</div>
                                    <div className="chat-input-2"></div>
                                    <div className="icon-mic-wrapper-2">
                                        <div className="icon-mic-2" style={{ marginLeft: 5 }}><MdOutlinePhotoCamera /></div>
                                        <div className="icon-mic-2"><AiOutlineAudio /></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="vidro-fosco-lindo">
                            <div className="propaganda-conteudo">
                                <h2 className="titulo-destaque">Promoção Imperdível!</h2>
                                <p><PiCertificate style={{fontSize: 24, position: "relative", top: 5}}/> Ganhe um <strong>Certificado Digital</strong> totalmente gratuito</p>
                                <p className="texto-principal">
                                    Agora receba a sua <strong>DAS <IoDocumentTextOutline /></strong> <br /> na palma da mão, pelo Zap-MEI!
                                </p>
                            </div>
                        </div>
                    </section>
                
            </div>
        </>
    );
}